export default {
    _private: {
        logout: "退出登录",
        title: {
            home: "首页",
            systemSet: "系统设置",
            userManage: "用户管理",
            roleManage: "角色管理",
            departmentManage: "部门管理",
            tms: "管车数据",
            carrierManage: "承运商管理",
            tableColumnSet: "表格列设置",
            hiddenColumn: "隐藏列",
            displayColumn: "显示列",
            addUser: "用户新增",
            editUser: "用户修改",
            terminalManage: "设备管理",
            addCarrier: "新增承运商",
            editCarrier: "修改承运商",
            vehicleManage: "车辆管理",
            waybillManage: "运单管理"
        },
        button: {
            search: "查询",
            reset: "重置",
            operate: "操作",
            edit: "编辑",
            confirm: "确定",
            cancel: "取消",
            submit: "提交",
            return: "返回",
            detail: "详情"
        },
        label: {
            userName: "用户名",
            userCode: "登录名",
            department: "部门",
            role: "角色名",
            password: "密码",
            confirmPassword: "确认密码",
            phone: "手机",
            telephone: "固定电话",
            email: "邮箱",
            address: "地址",
            remark: "备注",
            contract: "联系人",
            contractTel: "联系人电话",
            commids: "中心识别码",
            terminalName: "设备名称",
            terminalNo: "设备编号",
            terminalTypeText: "设备类型",
            bindingObjectText: "绑定类型",
            bindingNo: "绑定对象",
            simNo: "SIM卡",
            orgName: "部门",
            supplierName: "供应商",
            specification: "规格型号",
            productionDate: "生产日期",
            installDate: "安装日期",
            onlineStatus: "设备状态",
            terminalStatus: "在线状态"
        },
        placeholder: {
            userName: "用户名",
            userCode: "登录名",
            department: "部门",
            role: "角色名",
            password: "密码",
            confirmPassword: "确认密码",
            phone: "手机",
            telephone: "固定电话",
            email: "邮箱",
            address: "地址",
            remark: "备注",
            contract: "联系人",
            contractTel: "联系人电话",
            commids: "中心识别码",
            vehicleList: "选择车辆",
            vehicleTypeGb: "请选择车辆类型",
            vehicleType: "货运类型",
            vehicleBrand: "车辆品牌",
            mainDriverId: "请选择主司机",
            assistantDriverId: "请选择副司机",
            vehicleNo: "车牌号",
            terminalNo: "设备编号",
            terminalName: "设备名称",
            terminalTypeText: "设备类型",
            bindingObjectText: "绑定对象"
        },
        rule: {
            userName: "请输入用户名",
            userCode: "请输入登录名",
            department: "请选择部门",
            role: "请输入角色",
            password: "请输入密码",
            confirmPassword: "请再次确认密码",
            phone: "请输入手机",
            telephone: "请输入电话",
            email: "请输入邮箱",
            address: "请输入地址",
            carrierName: "请输入承运商名称",
            vehicleNo: "请输入车牌号",
            equip: "请选择设备",
            vehicleProperty: "请选择车辆属性",
            vehicleTypeGb: "请选择车辆类型",
            terminalNo: "请输入设备编号",
            terminalName: "请输入设备名称",
            terminalType: "请选择设备类型",
            bindingId: "请选择绑定对象",
            commids: "请输入中心识别码",
            simNo: "请输入SIM卡"
        },
        message: {
            atLeastOneUser: "至少选择一个用户！",
            deleteUser: "确认删除用户？",
            deleteCarrier: "确认删除承运商?"
        }
    }
};
